import apiHandler from "../core/apiHandler";

const hardwareTestApi = apiHandler('hardware/test');
export default hardwareTestApi;